Namespace 'Common.Dashboard.Charts'

class Common.Dashboard.Charts.SessionCustomChartListItemViewFactory
  canHandle: (configuredCharts, session) ->
    true

  create: (session) ->
    new Common.Dashboard.Charts.SessionCustomChartListItemView(session)
